const isDecimal = (val: any) => {
  const num = Number(val);
  return !isNaN(num) && isFinite(num);
};
function isGuid(val: any) {
  const regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(val);
}

function isEmptyOrSpaces(str: string): boolean {
  return str.trim().length === 0;
}

export { isDecimal, isGuid, isEmptyOrSpaces };
